export const licensing = {
    restrict: ['lesson', 'lessons-list', 'activities-list', 'corpus'],
    visible: true,
};